<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <div class="row sponsors-list">

          <div class="col-lg-4 col-md-6" v-for="(item, index) in sponsor" :key="index">
            <a :href="item.link" target="_blank">
              <img :src="require('@/assets/img/'+item.cover)" :alt="item.title" :title="item.title">
            </a>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  import sponsorData from "@/assets/data/sponsor.json";
  export default {
    name: "Donation",
    components: {
      PageBanner,
      Breadcrumbs
    },
    data() {
      return {
        sponsor:sponsorData
      }
    }
  };
</script>